package com.example.positionahead.ui.screens

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.Checkbox
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.material3.TopAppBar
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.unit.dp
import com.example.positionahead.domain.CsvImportTemplate
import com.example.positionahead.ui.components.DownloadCsvTemplateButton
import com.example.positionahead.ui.components.UploadCsvButton

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun ImportScreen(
    importErrors: List<String>,
    importSuccessCount: Int,
    onImport: (String, replaceExisting: Boolean) -> Unit,
    onClearStatus: () -> Unit,
    embedded: Boolean = false,
    modifier: Modifier = Modifier,
) {
    var replaceExisting by remember { mutableStateOf(true) }

    Column(modifier = modifier.fillMaxSize()) {
        if (!embedded) {
            TopAppBar(title = { Text("Import Positions") })
        }

        Column(
            modifier = Modifier
                .then(if (embedded) Modifier.fillMaxWidth() else Modifier.fillMaxSize())
                .then(if (embedded) Modifier else Modifier.verticalScroll(rememberScrollState()))
                .padding(if (embedded) 0.dp else 16.dp),
            verticalArrangement = Arrangement.spacedBy(12.dp),
        ) {
            if (!embedded) {
                Text(
                    "Upload a CSV file from your broker. Supports Symbol, Price, Quantity, Date exports.",
                    style = MaterialTheme.typography.bodyMedium,
                )
                Text(
                    "To add positions one at a time, use the Add tab instead.",
                    style = MaterialTheme.typography.bodySmall,
                    color = MaterialTheme.colorScheme.onSurface.copy(alpha = 0.6f),
                )
            }

            Row(
                modifier = Modifier.fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically,
            ) {
                Checkbox(checked = replaceExisting, onCheckedChange = { replaceExisting = it })
                Text("Replace existing positions in this account")
            }

            DownloadCsvTemplateButton(modifier = Modifier.fillMaxWidth())

            UploadCsvButton(
                onCsvLoaded = { content ->
                    onClearStatus()
                    onImport(content, replaceExisting)
                },
                modifier = Modifier.fillMaxWidth(),
            )

            Text(
                "Template preview",
                style = MaterialTheme.typography.labelMedium,
                color = MaterialTheme.colorScheme.onSurface.copy(alpha = 0.7f),
            )
            Card(
                modifier = Modifier.fillMaxWidth(),
                colors = CardDefaults.cardColors(
                    containerColor = MaterialTheme.colorScheme.surfaceVariant.copy(alpha = 0.5f),
                ),
            ) {
                Text(
                    text = CsvImportTemplate.content,
                    modifier = Modifier.padding(12.dp),
                    style = MaterialTheme.typography.bodySmall,
                    fontFamily = FontFamily.Monospace,
                )
            }

            if (importSuccessCount > 0) {
                Text(
                    "Imported $importSuccessCount lot(s) successfully.",
                    color = MaterialTheme.colorScheme.primary,
                )
            }
            importErrors.forEach { err ->
                Text(err, color = MaterialTheme.colorScheme.error, style = MaterialTheme.typography.bodySmall)
            }
        }
    }
}
